var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Replace or upload as new file:", centered: "" },
      on: { hide: _vm.closeHandler, ok: _vm.ok },
    },
    [
      _vm._v(
        "\n  One or more items already exists in this location. Do you want to replace the existing items with a new version or keep both items?\n\n  "
      ),
      _c(
        "ul",
        { staticClass: "text-break" },
        _vm._l(_vm.files, function (file) {
          return _c("li", { key: file.id }, [
            _vm._v("\n      " + _vm._s(file.data?.name_only) + "\n    "),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        [
          _c(
            "b-form-radio",
            {
              attrs: { value: 1 },
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            },
            [_vm._v("\n      Replace existing items\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-form-radio",
            {
              attrs: { value: 2 },
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            },
            [_vm._v("\n      Keep all items\n    ")]
          ),
          _vm._v(" "),
          _c(
            "b-form-radio",
            {
              attrs: { value: 3 },
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            },
            [_vm._v("\n      Stop\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }